import { defineMessages } from 'react-intl';

export const validationMessages = defineMessages({
  // Product Info
  productNameRequired: {
    description: 'Validation error when product name is empty',
    defaultMessage: 'Product name is required.',
    id: 'ZPcc3/',
  },
  productNameTooLong: {
    description: 'Validation error when product name exceeds max characters',
    defaultMessage: 'Product name must be {maxLength} characters or less.',
    id: 'lpfalr',
  },
  productSkuRequired: {
    description: 'Validation error when product SKU is empty for new products',
    defaultMessage: 'Product SKU is required.',
    id: 'ksCKdk',
  },
  productSkuTooLong: {
    description: 'Validation error when product SKU exceeds max characters',
    defaultMessage: 'Product SKU must be {maxLength} characters or less.',
    id: 'fCbuV5',
  },
  upcTooLong: {
    description: 'Validation error when UPC exceeds max characters',
    defaultMessage: 'UPC must be {maxLength} characters or less.',
    id: 'ov2oel',
  },
  barcodeTooLong: {
    description: 'Validation error when Barcode exceeds max characters, shown when barcode fields are enabled',
    defaultMessage: 'Barcode must be {maxLength} characters or less.',
    id: 'IoWdU6',
  },

  // Warehouse Location
  warehouseLocationTooLong: {
    description: 'Validation error when warehouse location exceeds max characters',
    defaultMessage: 'Warehouse location must be {maxLength} characters or less.',
    id: 'tQZvrq',
  },

  // Customs
  customsValueTooHigh: {
    description: 'Validation error when declared value exceeds max',
    defaultMessage: 'Declared value cannot exceed {maxValue}.',
    id: 'A1aOSh',
  },
  midCodeInvalidCharacters: {
    description: 'Validation error when MID code contains non-alphanumeric characters',
    defaultMessage: 'MID code can only contain letters and digits.',
    id: 'u+jdGt',
  },
});
